@if (displayInCarousel()) {
  <div class="mx-2">
    <app-carousel [value]="elementList()" [dark]="true" [stateKey]="stateKey()">
      <ng-template let-auction pTemplate="item">
        <div class="mx-1 element-dimensions">
          <ng-container
            *ngTemplateOutlet="template; context: { $implicit: auction }">
          </ng-container>
        </div>
      </ng-template>
    </app-carousel>
  </div>
} @else {
  <div class="auctions-memorabid">
    <div class="bid-showcase-inner">
      <div class="auctions-memorabid">
        <div class="bid-box-grid pb-4 pt-2">
          @for(item of elementList(); track $index) {
            <ng-template
              [ngTemplateOutlet]="template"
              [ngTemplateOutletContext]="{ $implicit: item }"
            />
          }
        </div>
      </div>
    </div>
  </div>
}


